<template>
    <div class="main-container">
        <div class="main-form">
            <v-card>
            <v-card-text>
            <div class="form">
                <div class="form__row">
                    <label class="form__label" for="arena-edit-partner">Partner (not required)</label>
                    <div class="form__input-box">
                        <select id="arena-edit-partner" class="form__select" v-model="partnerId">
                            <option value="null">----------</option>
                            <option v-for="partner in partners" :value="partner.id" :key="partner.id">
                                {{ partner.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form__row">
                    <label class="form__label" for="arena-edit-domain">Arena domain</label>

                    <div class="multiple-inputs-wrap">
                        <div class="form__input-box form__input-box--small">
                            <select id="arena-edit-schema" class="form__select" disabled v-model="chosenArena.schema" aria-label="Protocol">
                                <option value="http">http</option>
                                <option value="https">https</option>
                            </select>
                        </div>

                        <div class="form__input-box">
                            <input id="arena-edit-domain" disabled type="text" class="form__input" :value="chosenArena.domain" />
                        </div>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-name">Arena name</label>
                        <input id="arena-edit-name" disabled type="text" class="form__input" :value="chosenArena.name" />
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-locale">Default locale (required)</label>
                        <select id="arena-edit-locale" class="form__select" v-model="chosenArena.config.theme.locale" data-testid="arena-edit-locale-select">
                            <option :key="loc.value" :value="loc.value" v-for="loc in locales">{{ loc.name }}</option>
                        </select>
                    </div>
                </div>

        <div class="form__row form__row--feed">
          <span class="form__label" id="arena-edit-feed-label">Feed</span>

          <div class="multiple-inputs-wrap">
            <div class="form__input-box">
              <v-autocomplete outlined
                        dense
                        hide-details
                        id="arena-edit-feed"
                        aria-labelledby="arena-edit-feed-label"
                        v-model="selectedFeedId"
                        :items="feeds || []"
                        :item-text="feedOptionText"
                        item-value="id"
                        :loading="!feeds || feeds.length === 0"
                        :disabled="!feeds || feeds.length === 0"
                        data-testid="arena-edit-feed-select">
              </v-autocomplete>
            </div>
            <div class="form__input-box form__input-box--feed-action">
              <v-btn
                dense
                :href="selectedFeedHref"
                target="_blank"
                rel="noopener noreferrer"
                :disabled="!canOpenSelectedFeed"
                data-testid="arena-edit-open-feed-btn"
              >
                Open feed
              </v-btn>
            </div>
          </div>
        </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-ga">Add Google Analytics or leave it blank to auto generate it </label>
                        <input id="arena-edit-ga" disabled type="text" class="form__input" :value="chosenArena.analytics.account" />
                    </div>
                </div>

                <div class="form__row">
                    <label class="form__label" for="arena-edit-sample-rate">AppInsights Sample rate (if blank, default value 50 (of 100) is used).</label>
                    <div class="form__input-box form__input-box--small">
                        <input
                            id="arena-edit-sample-rate"
                            type="number"
                            class="form__input"
                            v-model="chosenArena.analytics.appInsightsSampleRate"
                            name="appInsightsSampleRate"
                            v-input-trim
                        />
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-facebook">Facebook Application ID - use for user login on arena</label>
                        <input
                            id="arena-edit-facebook"
                            type="text"
                            class="form__input"
                            v-model="chosenArena.config.facebookAppId"
                            name="facebookAppId"
                            v-input-trim
                            data-testid="arena-edit-facebook-input"
                        />
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-home">Client home page url for logo link</label>
                        <input
                            id="arena-edit-home"
                            type="text"
                            class="form__input"
                            v-model="chosenArena.config.theme.clientHomePageUrl"
                            name="clientHomePageUrl"
                            v-input-trim
                            data-testid="arena-edit-home-input"
                        />
                    </div>
                </div>
                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-favicon">Upload favicon, it must be named <span class="form__important-text">favicon.png</span></label>

                        <input
                            id="arena-edit-favicon"
                            type="file"
                            :class="{ form__input: true, 'is-error': errors.has('favicon') }"
                            v-validate="faviconRules"
                            ref="faviconInput"
                            name="favicon"
                            @change="processFile($event, 'favicon')"
                            data-testid="arena-edit-favicon-input"
                        />

                        <span class="form__error" v-show="errors.has('favicon')">{{ errors.first('favicon') }}</span>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-logo">Upload logo, it must be named <span class="form__important-text">logo.png</span></label>

                        <input
                            id="arena-edit-logo"
                            type="file"
                            :class="{ form__input: true, 'is-error': errors.has('logo') }"
                            v-validate="logoRules"
                            ref="logoInput"
                            name="logo"
                            @change="processFile($event, 'logo')"
                            data-testid="arena-edit-logo-input"
                        />

                        <span class="form__error" v-show="errors.has('logo')">{{ errors.first('logo') }}</span>
                    </div>
                </div>

                <div class="form__row">
                    <label class="form__label" for="arena-edit-preroll">Preroll show rate (0 - disabled, 2 - every 2 game plays, 3 - every 3 game plays etc.)</label>
                    <div class="form__input-box form__input-box--small">
                        <input
                            id="arena-edit-preroll"
                            type="number"
                            class="form__input"
                            v-model="chosenArena.config.theme.ads.DisableVideo.prerollShowRate"
                            name="video"
                            v-input-trim
                        />
                    </div>
                </div>
                <div class="form__row">
                    <v-checkbox v-model="chosenArena.config.theme.isCanary" label="Is Canary arena" class="mx-2">
                    </v-checkbox>
                </div>

                <div class="form__row">
                    <v-checkbox
                        v-model="chosenArena.config.theme.supportRewardVideo"
                        label="Support Reward Video"
                        class="mx-2"
                    >
                    </v-checkbox>
                </div>

                <div class="form__row">
                    <v-checkbox
                        v-model="chosenArena.config.theme.supportInterstitialVideo"
                        label="Support Interstitial Video"
                        class="mx-2"
                    >
                    </v-checkbox>
                </div>

                <div class="form__row">
                    <v-checkbox
                        v-model="chosenArena.config.isGdprSupport"
                        label="Enable Full GDPR Support"
                        class="mx-2"
                    >
                    </v-checkbox>
                </div>

                <div class="form__row">
                    <v-checkbox v-model="chosenArena.config.isEagle" label="Enable Eagle login" class="mx-2">
                    </v-checkbox>
                </div>

                <div class="form__row">
                    <v-checkbox v-model="chosenArena.config.isGemsSupport" label="Enable Gems" class="mx-2">
                    </v-checkbox>
                </div>

                <div class="form__row" style="padding-top: 20px">
                    <p class="form__label"><b>LiveOps section</b></p>
                </div>

                <div class="form__row">
                    <label class="form__label" for="arena-edit-nest">Nest Environment</label>
                    <select id="arena-edit-nest" class="form__select" v-model="chosenArena.config.nestEnvironment" data-testid="arena-edit-nest-select">
                        <option :key="env.value" :value="env.value" v-for="env in nestEnvironments">
                            {{ env.name }}
                        </option>
                    </select>
                </div>

                <div class="form__row" style="padding-top: 20px">
                    <p class="form__label"><b>Only for they sell clients:</b></p>
                </div>
                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-video">They sell video lib. setting</label>
                        <input
                            id="arena-edit-video"
                            type="text"
                            class="form__input"
                            v-model="chosenArena.config.ad.theySell.video"
                            name="video"
                            v-input-trim
                            data-testid="arena-edit-video-input"
                        />
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__input-box">
                        <label class="form__label" for="arena-edit-display">They sell display lib. setting</label>
                        <input
                            id="arena-edit-display"
                            type="text"
                            class="form__input"
                            v-model="chosenArena.config.ad.theySell.display"
                            name="display"
                            v-input-trim
                            data-testid="arena-edit-display-input"
                        />
                    </div>
                </div>
                <div class="form__row">
                    <label class="form__label" for="arena-edit-chat">Open Web Char - Spot ID (the chat will be hidden if field is empty)</label>
                    <div class="form__input-box form__input-box--small">
                        <input
                            id="arena-edit-chat"
                            type="text"
                            class="form__input"
                            v-model="chosenArena.config.openWebChatId"
                            name="openweb"
                            v-input-trim
                            data-testid="arena-edit-chat-input"
                        />
                    </div>
                </div>
                <div class="form__row">
                    <label class="form__label" for="arena-edit-feedback">Url to User Feedback form</label>
                    <div class="form__input-box">
                        <input
                            id="arena-edit-feedback"
                            type="text"
                            class="form__input"
                            v-model="chosenArena.config.userFeedbackUrl"
                            name="userfeedback"
                            v-input-trim
                            data-testid="arena-edit-feedback-input"
                        />
                    </div>
                </div>
                <div class="form__row" v-if="editArenaError">
                    <span class="creation-edition-error">{{ editArenaError }}</span>
                </div>
            </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="$checkRoles(['Administrator'])"
                    color="success"
                    :loading="isLoadingBtn"
                    @click="editArena"
                    data-testid="arena-save-btn"
                >
                    Save General Settings
                </v-btn>
            </v-card-actions>
            </v-card>
        </div>

        <InfoModal
            v-if="arenaIsEdited"
            :msg="'Arena was successfully edited.'"
            :onCloseModal="closeInfoModal"
        ></InfoModal>
    </div>
</template>

<script>
import config from '../../../config';
import Loader from '../../Loader/Loader.vue';
import InfoModal from '../../InfoModal/InfoModal.vue';

export default {
    components: { Loader, InfoModal },
    name: 'EditForm',
    props: ['chosenArena', 'chosenArenaMeta', 'locales', 'feeds', 'sortings', 'partners', 'nestEnvironments'],
    data() {
        return {
            editArenaError: '',
            isLoadingBtn: false, // showing loader in the submit btn
            arenaIsEdited: false, // arena edited success flag
            favicon: null,
            logo: null,
            partnerId: null,
            selectedFeedId: 0,
            selectedFeed: null
        };
    },
    created() {
        // Component created
    },
    mounted() {
        // Component mounted
    },
    updated() {
        if (this.chosenArena && this.chosenArena.config && this.chosenArena.config.feed) {
            if (!this.chosenArena.config.feed.sorting) {
                this.chosenArena.config.feed.sorting = '';
            }
        }
    },
    watch: {
        chosenArena: {
            immediate: true,
            handler(newVal, oldVal) {
                // Ensure newVal exists and has required properties
                if (!newVal) {
                    return;
                }
                
                // Ensure config exists
                if (!newVal.config) {
                    newVal.config = {};
                }
                
                // Ensure config.feed exists
                if (!newVal.config.feed) {
                    newVal.config.feed = {};
                }
                if (!newVal.config.feed.feedName) {
                    newVal.config.feed.feedName = 'default';
                }
                if (!newVal.config.feed.sorting) {
                    newVal.config.feed.sorting = '';
                }
                
                // Ensure config.theme exists
                if (!newVal.config.theme) {
                    newVal.config.theme = {};
                }
                
                // Ensure config.ad exists
                if (!newVal.config.ad) {
                    newVal.config.ad = {};
                }
                
                // Ensure config.ad.theySell exists
                if (!newVal.config.ad.theySell) {
                    newVal.config.ad.theySell = {};
                }
                
                // Ensure analytics exists
                if (!newVal.analytics) {
                    newVal.analytics = {};
                }
                
                if (Number.isInteger(newVal.config.feed.feedName)) {
                    this.chosenArena.config.feed.feedName = newVal.config.feed.feedName.toString();
                }
                if (newVal.config.feed.feedName === null) {
                    this.chosenArena.config.feed.feedName = 'default';
                }

                this.selectedFeedId = Number.parseInt(this.chosenArena.config.feed.feedId, 10) || 0;
                this.selectedFeed = this.chosenArena.config.feed.feedName || 'default';
                
                if (newVal.config.ad.theySell === null) {
                    this.chosenArena.config.ad.theySell = {};
                    this.chosenArena.config.ad.theySell.display = '';
                    this.chosenArena.config.ad.theySell.video = '';
                }
                this.chosenArena.analytics.appInsightsSampleRate = newVal.analytics.appInsightsSampleRate || null;
                this.partnerId = this.chosenArenaMeta.partner ? this.chosenArenaMeta.partner.id : null;
            },
        },
    },
    computed: {
        canOpenSelectedFeed() {
            return Number(this.selectedFeedId) > 0;
        },
        selectedFeedHref() {
            return this.canOpenSelectedFeed ? `/feeds/${this.selectedFeedId}` : undefined;
        },
        faviconRules() {
            return {
                image: true,
                mimes: 'image/png',
                fileNameCheck: 'favicon.png', // checking file name with this string
            };
        },
        logoRules() {
            return {
                image: true,
                mimes: 'image/png',
                fileNameCheck: 'logo.png', // checking file name with this string
            };
        }
    },
    methods: {
        feedOptionText(item) {
            if (!item) {
                return '';
            }
            return `#${item.id} Name: ${item.name} Type: ${item.environment}`;
        },
        processFile: function (e, file) {
            this[file] = e.target.files[0]; // adding file to this.logo or this.favicon
        },
        findDomainByName(domains, name) {
            return Array.isArray(domains) ? domains.find((d) => d.name === name) : null;
        },
        async syncArenaDomainToSelectedFeed() {
            const domainName = this.chosenArena && this.chosenArena.domain;
            if (!domainName) {
                return;
            }

            const previousFeedId = Number.parseInt(
                this.chosenArena.config && this.chosenArena.config.feed && this.chosenArena.config.feed.feedId,
                10
            ) || 0;
            const nextFeedId = this.selectedFeedId;
            const feedChanged = previousFeedId && previousFeedId !== nextFeedId;

            if (feedChanged) {
                try {
                    const oldFeedDomains = await this.$gameApi.get(`/domains?feedId=${previousFeedId}`);
                    const existingOnOldFeed = this.findDomainByName(oldFeedDomains, domainName);
                    if (existingOnOldFeed) {
                        await this.$gameApi.delete(`/domains/${existingOnOldFeed.id}`);
                    }
                } catch (domainError) {
                    console.error('Error removing domain from previous feed:', domainError);
                }
            }

            try {
                if (nextFeedId) {
                    const newFeedDomains = await this.$gameApi.get(`/domains?feedId=${nextFeedId}`);
                    const existingOnNewFeed = this.findDomainByName(newFeedDomains, domainName);

                    if (existingOnNewFeed) {
                        await this.$gameApi.patch(`/domains/${existingOnNewFeed.id}`, {
                            id: existingOnNewFeed.id,
                            name: domainName,
                            feedId: nextFeedId
                        });
                    } else {
                        await this.$gameApi.post('/domains', {
                            name: domainName,
                            feedId: nextFeedId
                        });
                    }
                }
            } catch (domainError) {
                console.error('Error updating/creating domain in game-api:', domainError);
            }
        },
        editArena: function () {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    // showing loader in btn
                    this.isLoadingBtn = true;

                    const formData = new FormData();

                    formData.append(
                        'JsonData',
                        JSON.stringify({
                            PartnerId: this.partnerId,
                            Domain: this.chosenArena.domain,
                            ArenaFeedId: this.selectedFeedId,
                            ArenaFeed: this.selectedFeed,
                            Sorting: this.chosenArena.config.feed.sorting,
                            LocalPath: 'assets/png',
                            ClientHomePageUrl: this.chosenArena.config.theme.clientHomePageUrl,
                            FacebookAppId: this.chosenArena.config.facebookAppId,
                            Locale: this.chosenArena.config.theme.locale,
                            Video: this.chosenArena.config.ad.theySell.video,
                            Display: this.chosenArena.config.ad.theySell.display,
                            PrerollShowRate: this.chosenArena.config.theme.ads.DisableVideo.prerollShowRate,
                            IsCanary: this.chosenArena.config.theme.isCanary,
                            IsSupportRewardVideo: this.chosenArena.config.theme.supportRewardVideo,
                            IsSupportInterstitialVideo: this.chosenArena.config.theme.supportInterstitialVideo,
                            AppInsightsSampleRate: this.chosenArena.analytics.appInsightsSampleRate,
                            IsEagle: this.chosenArena.config.isEagle,
                            NestEnvironment: this.chosenArena.config.nestEnvironment,
                            IsGemsSupport: this.chosenArena.config.isGemsSupport,
                            IsGdprSupport: this.chosenArena.config.isGdprSupport,
                            OpenWebChatId: this.chosenArena.config.openWebChatId,
                            UserFeedbackUrl: this.chosenArena.config.userFeedbackUrl,
                        })
                    );

                    if (this.logo) formData.append('logo', this.logo);
                    if (this.favicon) formData.append('favicon', this.favicon);

                    this.$http.put(`${config.apiUrl}/arena/update`, formData).then(
                        async (response) => {
                            await this.syncArenaDomainToSelectedFeed();

                            this.isLoadingBtn = false;
                            this.arenaIsEdited = true;
                            this.$refs.logoInput.value = ''; // clearing input after success
                            this.$refs.faviconInput.value = ''; // clearing input after success
                        },
                        (error) => {
                            console.log(error, 'edit arena error');
                            this.isLoadingBtn = false;
                            this.editArenaError = error.body.Message
                                ? error.body.Message
                                : 'Something went wrong with edition of arena';
                        }
                    );
                }
            });
        },
        closeInfoModal: function () {
            this.arenaIsEdited = false;
        },
    },
};
</script>

<style scoped lang="scss">
.main-form {
  max-width: 560px;
}

.form__row--feed .multiple-inputs-wrap {
  flex-wrap: nowrap;
  align-items: center;
}

.form__row--feed .form__input-box:first-child {
  min-width: 0;
  flex: 1 1 auto;
}

.form__input-box--feed-action {
  width: auto;
  flex: 0 0 auto;
}
</style>
